import { Link } from 'react-router-dom';
import { loadNOTAMData } from '@/utils/yamlLoader';

export function NOTAMBanner() {
  const { notams } = loadNOTAMData();

  const activeNOTAMs = notams.filter(notam => {
    if (notam.status !== 'active') return false;
    const now = new Date();
    const effectiveDate = new Date(notam.effectiveDate);
    const expirationDate = new Date(notam.expirationDate);
    return now >= effectiveDate && now <= expirationDate;
  });

  if (activeNOTAMs.length === 0) {
    return null;
  }

  const notamCount = activeNOTAMs.length;
  const isPlural = notamCount > 1;

  return (
    <div className="bg-blue-50 border-b border-blue-200 text-blue-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-end space-x-4">
          <div className="flex items-center space-x-2">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-blue-600"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <span className="text-sm font-medium">
              {notamCount} active NOTAM{isPlural ? 's' : ''}
            </span>
          </div>

          <Link
            to="/notams"
            className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-2 rounded-lg border border-blue-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            View NOTAMs
          </Link>
        </div>
      </div>
    </div>
  );
}